import { Button, HStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useProposal } from '../contexts/ProposalContext'

// The three gestures a meeting needs on a proposal: the circle approves, the
// circle refuses, or the text is amended after discussion (D6, B1 and B4).
//
// They replace the "manage" menu while in a meeting: resolving early and
// nudging people to vote both assume a tally that this mode never runs.
//
// Amending edits the proposal IN PLACE, and the edit modal is deliberately NOT
// rendered here: this component is unmounted the moment the proposal stops
// being in progress. A refuse-then-recreate variant was tried on 06/08/2026 and
// reverted for exactly that reason — the refusal tore down the component, and
// the modal it owned vanished with it before anything could be typed.
export default function ProposalResolveMeetingButtons() {
  const { t } = useTranslation()
  const { resolve, canEdit, editModal } = useProposal()
  const [submitting, setSubmitting] = useState(false)

  const handleResolve = async (approved: boolean) => {
    // Guarded because applying the org-chart changes takes a moment, and a
    // second click would try to resolve a proposal that is no longer in
    // progress.
    if (submitting) return
    setSubmitting(true)
    try {
      await resolve(approved)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <HStack spacing={2}>
      <Button
        size="sm"
        colorScheme="green"
        isLoading={submitting}
        onClick={() => handleResolve(true)}
      >
        {t('ThreadActivityProposal.meetingApprove')}
      </Button>
      {/* Amending sits between the two outcomes because it is the third way out
          of the discussion, not a secondary action. */}
      {canEdit && (
        <Button
          size="sm"
          colorScheme="purple"
          isDisabled={submitting}
          onClick={editModal.onOpen}
        >
          {t('ThreadActivityProposal.meetingEdit')}
        </Button>
      )}
      <Button
        size="sm"
        colorScheme="red"
        isDisabled={submitting}
        onClick={() => handleResolve(false)}
      >
        {t('ThreadActivityProposal.meetingRefuse')}
      </Button>
    </HStack>
  )
}
